"use client"

import { useMutation } from "@tanstack/react-query"
import { saveParamAliasSetsAction, type SavedParamAliasSets } from "@/server-actions/attribution-param-aliases"
import type { UrlParamAliasSet } from "@/lib/attribution/url-param-aliases"
import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import { useTranslations } from "next-intl"


export function useSaveParamAliasSetsMutation() {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsAttributionParamAliases")

  return useMutation({
    mutationFn: async (variables: {
      integrationId: string
      paramAliasSets: UrlParamAliasSet[] | null
    }): Promise<SavedParamAliasSets> => {
      const result = await withQueryHandling(saveParamAliasSetsAction(variables), {
        loading: tUi("savingURLParameterAliases"),
        success: tUi("uRLParameterAliasesSaved"),
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
